// It doesn't make sense to convert Slack icon into our token, as Slack icon is a unique brand. Confirmed that it looks great in DarkMode without tokens.
// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';

export const SlackGlyph = (props: ComponentProps<'svg'>) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z"
			fill="white"
			fillOpacity="0.01"
		/>
		<path
			d="M6.78559 14.3429C6.78559 15.3857 5.94273 16.2286 4.89987 16.2286C3.85702 16.2286 3.01416 15.3857 3.01416 14.3429C3.01416 13.3 3.85702 12.4572 4.89987 12.4572H6.78559V14.3429ZM7.72845 14.3429C7.72845 13.3 8.5713 12.4572 9.61416 12.4572C10.657 12.4572 11.4999 13.3 11.4999 14.3429V19.0572C11.4999 20.1 10.657 20.9429 9.61416 20.9429C8.5713 20.9429 7.72845 20.1 7.72845 19.0572V14.3429Z"
			fill="#E01E5A"
		/>
		<path
			d="M9.61429 6.77143C8.57143 6.77143 7.72857 5.92857 7.72857 4.88571C7.72857 3.84286 8.57143 3 9.61429 3C10.6571 3 11.5 3.84286 11.5 4.88571V6.77143H9.61429ZM9.61429 7.72857C10.6571 7.72857 11.5 8.57143 11.5 9.61429C11.5 10.6571 10.6571 11.5 9.61429 11.5H4.88571C3.84286 11.5 3 10.6571 3 9.61429C3 8.57143 3.84286 7.72857 4.88571 7.72857H9.61429Z"
			fill="#36C5F0"
		/>
		<path
			d="M17.1713 9.61429C17.1713 8.57143 18.0142 7.72857 19.057 7.72857C20.0999 7.72857 20.9427 8.57143 20.9427 9.61429C20.9427 10.6571 20.0999 11.5 19.057 11.5H17.1713V9.61429ZM16.2285 9.61429C16.2285 10.6571 15.3856 11.5 14.3427 11.5C13.2999 11.5 12.457 10.6571 12.457 9.61429V4.88571C12.457 3.84286 13.2999 3 14.3427 3C15.3856 3 16.2285 3.84286 16.2285 4.88571V9.61429Z"
			fill="#2EB67D"
		/>
		<path
			d="M14.3427 17.1714C15.3856 17.1714 16.2285 18.0143 16.2285 19.0572C16.2285 20.1 15.3856 20.9429 14.3427 20.9429C13.2999 20.9429 12.457 20.1 12.457 19.0572V17.1714H14.3427ZM14.3427 16.2286C13.2999 16.2286 12.457 15.3857 12.457 14.3429C12.457 13.3 13.2999 12.4572 14.3427 12.4572H19.0713C20.1142 12.4572 20.957 13.3 20.957 14.3429C20.957 15.3857 20.1142 16.2286 19.0713 16.2286H14.3427Z"
			fill="#ECB22E"
		/>
	</svg>
);
